function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTree = function SvgTree(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 24.6,
    transform: "matrix(0.9417 -0.3363 0.3363 0.9417 -9.8015 7.4138)",
    style: {
      fill: "#1565C0"
    },
    width: 2,
    height: 14.9
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1565C0"
    },
    points: "38.1,39.3 33.1,25.5 24,11.8 14.9,25.5 9.9,39.3 8.1,38.7 13.2,24.4 24,8.2 34.9,24.7    39.9,38.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 31,
    transform: "matrix(0.3361 -0.9418 0.9418 0.3361 -9.2253 50.9127)",
    style: {
      fill: "#1565C0"
    },
    width: 14.9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E88E5"
    },
    d: "M28,10c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4S28,7.8,28,10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E88E5"
    },
    d: "M18,25c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4S18,22.8,18,25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E88E5"
    },
    d: "M38,25c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4S38,22.8,38,25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E88E5"
    },
    d: "M12,39c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S12,37.3,12,39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E88E5"
    },
    d: "M22,39c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S22,37.3,22,39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E88E5"
    },
    d: "M32,39c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S32,37.3,32,39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E88E5"
    },
    d: "M42,39c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S42,37.3,42,39z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTree, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tree.661c6d5b.svg";
export { ForwardRef as ReactComponent };